<template>
<span :style='{ height: `${wrapperHeight}px` }'>
    <Icon
        :name='icon'
        :width='size || width'
        :height='size || height'
        :original='original'
        :color='color'>
    </Icon>
</span>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class FwIcon extends Vue {
    @Prop({ type: String, required: true }) readonly icon!: string;
    @Prop({ type: String }) readonly color!: string;
    @Prop({ type: String, default: '20' }) readonly size!: string;
    @Prop({ type: String, default: '20' }) readonly width!: string;
    @Prop({ type: String, default: '20' }) readonly height!: string;
    @Prop({ type: String, default: 'auto' }) readonly wrapperHeight!: string;
    @Prop({ type: Boolean, default: false }) readonly original!: boolean;
}
</script>
